// Centralized runtime configuration. Validates required vars at module load
// (startup), so a missing REACT_APP_API_SERVER fails immediately rather than
// on first fetch. Bypassed under Jest (tests use MSW with no real backend).

const isTestEnvironment = typeof process.env.JEST_WORKER_ID !== "undefined";

function required(name) {
    const value = process.env[name];
    if (!value && !isTestEnvironment) {
        throw new Error(`Missing required env var: ${name}`);
    }
    return value;
}

export const API_SERVER = required("REACT_APP_API_SERVER");
export const STRIPE_PUBLISHABLE_KEY = required("REACT_APP_PUBLIC_STRIPE_PUBLISHABLE_KEY");
export const STRIPE_PORTAL_LINK = required("REACT_APP_STRIPE_PORTAL_LINK");
